<script>
  import { Image } from 'smelte'
  import { fade } from 'svelte/transition'
  import { push } from 'svelte-spa-router'
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  export let trackingID
  export let active = true
  export let ref = '#'
  export let type = 'component'
  export let title = 'Awesome App'
  export let details = ''
  export let pic = 'icon_097_maintenance_service.png'
  export let width = 400
  export let height = 310

  function navigate () {
    dispatch('navigate', {type, ref})
  }
</script>

<div data-tracking={trackingID} class="relative" style={`width: ${width}px; height: ${height}px;`}>
  {#if !active || ref.length <= 3}
    <div class="w-full h-full opacity-75 bg-white absolute top-0 left-0 z-20 overlay">
      &nbsp;
    </div>
  {/if}

  <div class="transition duration-500 w-full h-full flex flex-col items-center bg-white p-10 box hover:bg-red-500" class:slider={pic != null}
       on:click={navigate}
  >
    {#if pic != null}
    <div class="icon">
      <Image src="static/img/{pic}" alt="{pic}" width={70} />
    </div>
    {/if}

    <div class="text-block">
      <div class="uppercase mt-6 mb-5 font-medium tracking-wider title" style="font-size: 14px">{title}</div>
      <div class="leading-relaxed font-light details">{details}</div>
      <!--
      <div class="leading-relaxed font-light details">URL: {ref}</div>
      <div>{ref}</div>
      -->

      <div class="text-xs text-gray-900" style="font-family: icons">
        <span class="icon icon-arrow-link" />
      </div>

      <div class="text-xs text-gray-900" style="font-family: icons">
        <span class="icon2 icon-arrow-link" />
      </div>

    </div>
  </div>
</div>

<style>
    .box {
        border: 1px solid rgb(240, 240, 240);
        /*margin-left: -1px;*/
        /*margin-top: -1px;*/
    }

    .slider {
      padding-top: 4.5rem;
    }

    .box:hover {
        border: 0;
    }

    .box:hover .icon {
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s 0.1s, opacity 0.1s linear;
    }

    .box:hover .text-block {
        color: white;
    }

    .slider:hover .text-block {
        transform: translate(0, -50px);
        transition-timing-function: ease-in;
        transition-duration: 0.2s;
    }

    /*
    .box:hover .title {
        transition-timing-function: ease-in;
        transition-duration: 0.5s;
    }
  */

    .icon2 {
       opacity: 0;
    }
    .box:hover .icon2 {
        color: white;
        visibility: visible;
        opacity: 1;
        transition: visibility 0.2s 0.3s, opacity 0.3s linear;
    }

    .box:hover .details {
        font-weight: 400;
    }
</style>